import Seo from "components/Seo";
import React, { useEffect, useState } from "react";
import CustomerLayout from "./customerLayout";
import { useSearchParams } from "react-router-dom";
import { useMediaQuery } from "hooks/utils/useMediaQuery";
import PrintTracking from "../../-components/PrintTracking";
import TrackingPrintView from "../../-components/TrackingPrintView";

export default function MorningPrint() {
    const [searchParams] = useSearchParams();
    const [chkBlNumber, setChkBlNumber] = useState<string[] | null>(null);
    const responsive1000 = useMediaQuery(1000);
    const [showPrint, setShowPrint] = useState<boolean>(false);

    useEffect(() => {
        const chk_bl_no = searchParams.get("chk_bl_no") ?? "";
        if (responsive1000) {
            setChkBlNumber(null);
            setShowPrint(false);
        } else if (chk_bl_no && !showPrint) {
            setChkBlNumber([chk_bl_no]);
            setShowPrint(true);
        }
    }, [searchParams, responsive1000]);

    // console.log(showPrint);

    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="운송장 프린트" />
            <CustomerLayout>
                <div className="flex-1 bg-[#f8f8f8] flex flex-col items-center pt-12 responsive1200:pt-[30px] responsive600:px-[4%] responsive600:bg-white">
                    {/* <p className="text-[#1b1c1e] text-[36px] font-bold responsive1200:text-[24px] responsive1200:font-[500]">운송장 출력</p> */}

                    {showPrint && chkBlNumber && chkBlNumber?.length > 0 && (
                        // <div className="fixed inset-0 z-[200] bg-black bg-opacity-40 flex items-center justify-center">
                        <TrackingPrintView
                            bl_no={chkBlNumber ?? []}
                            onClose={() => {
                                setShowPrint(false);
                                setChkBlNumber(null);
                            }}
                        />
                        // </div>
                    )}
                </div>
            </CustomerLayout>
        </React.Fragment>
    );
}
